import { useMutation, useQuery, useQueryClient } from 'react-query';
import {
  accountReceivableObservationCreate,
  accountReceivableObservationDelete,
  accountReceivableObservationList,
  accountReceivableObservationUpdate,
} from './AccountReceivableObservation.service';
import { useServiceError } from '@/hooks';
import { AccountInstallmentReceivableObservationRequest } from './AccountReceivableObservation.types';

export function useAccountReceivableObservationCreate() {
  const queryClient = useQueryClient();

  const mutation = useMutation(accountReceivableObservationCreate, {
    onSuccess() {
      queryClient.invalidateQueries(['observation-list']);
    },
  });

  useServiceError(mutation.error);

  return mutation;
}

export function useAccountReceivableObservationList(
  obj: AccountInstallmentReceivableObservationRequest,
) {
  const query = useQuery(
    ['observation-list', obj.installmentReceivableId],
    () => accountReceivableObservationList(obj),
  );

  useServiceError(query.error);

  return query;
}

export function useAccountReceivableObservationUpdate() {
  const queryClient = useQueryClient();

  const mutation = useMutation(accountReceivableObservationUpdate, {
    onSuccess() {
      queryClient.invalidateQueries(['observation-list']);
    },
  });

  useServiceError(mutation.error);

  return mutation;
}

export function useAccountReceivableObservationDelete() {
  const queryClient = useQueryClient();

  const mutation = useMutation(accountReceivableObservationDelete, {
    onSuccess() {
      queryClient.invalidateQueries(['observation-list']);
    },
  });

  useServiceError(mutation.error);

  return mutation;
}
